export default {
    it: {
        "title": "Allegato",
        "drop-message": "Trascina i file qui o <span class='filepond--label-action'>Carica file</span>",
        "file-formats": "Tipi di file consentiti:  jpg, png, gif, pdf, p7e e p7m.",
        "max-dim": "La dimensione massima consentita per allegato è di: 1MB.",
        "max-file-number": "Numero massimo di allegati: ",
        "upload": "Carica file",
        "attachment-error": "Per favore carica almeno un allegato",
        "attachment-error-remove": "Per favore rimuovi i files non coerenti"


    },
    en: {
        "title": "Attachment",
        "drop-message": "Drop files here or <span class='filepond--label-action'>Browse</span>",
        "file-formats": "Allowed file types:  jpg, png, gif, pdf, p7e and p7m.",
        "max-dim": "The maximum allowed size per attachment is: 1MB.",
        "max-file-number": "Maximum number of attachments: ",
        "upload": "Upload file",
        "attachment-error": "Please upload at least one attachment",
        "attachment-error-remove": "Please remove inconsistent files"
    }
}